var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tinybox',{attrs:{"images":_vm.images},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}})
}
var staticRenderFns = []

export { render, staticRenderFns }